import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

export const STUDIO_LABELS = {
  enregistrement: "FNK STUDIO",
  media: "FNK FILMS",
};

export const STUDIO_SUBTITLES = {
  enregistrement: "Enregistrement · Mix · Master · Beatmaking",
  media: "Podcasts · Vidéo · Photo · Book · Clips · Interview",
};

export const STUDIO_LOGOS = {
  enregistrement: "/logo-fenek-studio.jpg",
  media: "/logo-fenek-films.jpg",
};

export const STATUS_LABELS = {
  en_attente_validation: "En attente de validation",
  en_attente_paiement: "En attente de paiement",
  confirmee: "Confirmée · Payée",
  reservee: "Confirmée · Paiement sur place",
  annulee: "Annulée",
};

export const CATEGORY_LABELS = {
  studio: "Sessions studio",
  complement: "Compléments de session",
  beatmaking_catalogue: "Beatmaking — Prods du catalogue (Phase A)",
  mariage: "Mariage — Formules (sur devis)",
  mariage_option: "Mariage — Options (sur devis)",
  media_supplement: "Suppléments tournage (sur demande)",
};

export const MEDIA_CATEGORY_LABELS = {
  teaser: "Teasers",
  mariage: "Mariages",
  clip: "Clips vidéo",
  photo: "Séances photo",
  book: "Books photo",
  podcast: "Podcasts & interviews",
  corporate: "Vidéos corporate",
  casting: "Danseurs & figurants",
  realisation: "Réalisations",
  autre: "Autres",
};

export const formatEuro = (amount) => {
  if (amount === null || amount === undefined) return "—";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatHour = (hour) => `${String(hour).padStart(2, "0")}:00`;

export const toDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
